import { Routes } from '@angular/router';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const servicePackagesRoutes: Routes = [
  {
    path: '',
    data: {
      permissions: {
        only: ['Admin', 'Administrator', 'Manager'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () =>
      import('./package-list/package-list.component').then(
        (m) => m.PackageListComponent
      ),
  },
  {
    path: 'new',
    data: {
      // Administrator can already create and sell a package from the booking modal,
      // which is ungated, so blocking the same action here was inconsistent rather
      // than protective — the list, purchases and view routes already allow the role
      // (beaut-395).
      //
      // The buttons in package-list now gate on this SAME role list. They used
      // `service_packages.manage`, which is seeded for Manager only and never for
      // Administrator (not a seeded role at all), so fixing the route alone left
      // the role on a page with no buttons — reported as still broken in prod.
      permissions: {
        only: ['Admin', 'Administrator', 'Manager'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () =>
      import('./package-form/package-form.component').then(
        (m) => m.PackageFormComponent
      ),
  },
  {
    path: 'purchases',
    data: {
      permissions: {
        only: ['Admin', 'Administrator', 'Manager'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () =>
      import('./package-purchases/package-purchases.component').then(
        (m) => m.PackagePurchasesComponent
      ),
  },
  {
    path: ':id',
    data: {
      permissions: {
        only: ['Admin', 'Administrator', 'Manager'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () =>
      import('./package-view/package-view.component').then(
        (m) => m.PackageViewComponent
      ),
  },
  {
    path: ':id/edit',
    data: {
      // Same as 'new' above (beaut-395): kept in step with the other routes in this file.
      permissions: {
        only: ['Admin', 'Administrator', 'Manager'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () =>
      import('./package-form/package-form.component').then(
        (m) => m.PackageFormComponent
      ),
  },
];
